import React from "react";
import { Grid } from "@mui/material";
import { ReferenceInput, SelectInput, useSimpleFormIteratorItem } from "react-admin";
import { useWatch } from "react-hook-form";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { administrationRequests } from "api/administrationApi";

// One „Отделения служители“ row. A ward already picked in another row is excluded from this
// row's choices (the wards select supports ExcludeIds), so the same ward can't be added twice.
// The row's own ward is never excluded, so its current value stays selectable.
const WardEmployeeRow = () => {
  const { index } = useSimpleFormIteratorItem();
  const wardsEmployees = useWatch({ name: "wardsEmployees" });
  const excludeIds =
    wardsEmployees
      ?.filter((_, i) => i !== index)
      .map(row => row?.wardId)
      .filter(Boolean) ?? [];

  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="wardId"
          reference={administrationRequests.getWardsSelect()}
          filter={excludeIds.length ? { excludeIds } : undefined}
        >
          <SelectInput
            optionText="name"
            label="Болнично отделение"
            emptyText={false}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ProfessorInput source="employeeId" />
      </Grid>
    </>
  );
};

export default WardEmployeeRow;
